<dashboardnav>
  <cradua-documenttype
  [documenttypes]="documenttypes$ | async"
  (documenttype)="onSubmitDocumentType($event)"
  (deleteDocumentTypeEvent)="onDeleteDocumentType($event)"
  *ngIf="(isLoadingDocumentType$ | async ) === false"
  >
</cradua-documenttype>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingDocumentType$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
